import(/* webpackMode: "eager", webpackExports: ["ApplyHeader"] */ "/workspace/purple-ventures/src/components/layout/apply-header.tsx");
